<template>
  <div class="container">
    <div class="row">
      <div class="col-sm">
        <form class="form-inline">
          <input
            v-model="showDate"
            @change="loadChannel()"
            type="date"
            id="showDate"
            class="form-control"
          />

          <select
            v-model="channelCode"
            @change="loadChannel()"
            id="channelCode"
            class="form-control ml-sm-2"
          >
            <option value>Channel</option>
            <option
              v-for="channel in channels"
              :value="channel.Number"
              :key="channel.Number"
            >{{channel.Name}} {{channel.Number}}</option>
          </select>
        </form>
      </div>
    </div>
    <br />
    <router-view />
  </div>
</template>

<script>
import API from "../apis/firstmedia.js";
import _ from "lodash";
import moment from "moment";

export default {
  data() {
    return {
      fromServer: [],
      showDate: moment().format("YYYY-MM-DD"),
      channelCode: ""
    };
  },
  computed: {
    channels: function() {
      if (!this.fromServer.Channels) {
        return [];
      }

      let transformed = _.sortBy(this.fromServer.Channels, ["Name", "Number"]);
      return transformed;
    }
  },
  async created() {
    let token = await this.$store.dispatch("spinner/needSpinner");
    let response = await API.getChannel();
    this.$store.dispatch("spinner/dontNeedSpinner", token);
    this.fromServer = response;
  },
  methods: {
    loadChannel: function() {
      if (!this.channelCode || !this.showDate) {
        return;
      }
      let routeParams = {
        name: "masterdetailselected",
        params: { chcode: this.channelCode }
      };
      let today = moment().format("YYYY-MM-DD");
      if (this.showDate != today) {
        routeParams.query = {
          showdate: this.showDate
        };
      }
      this.$router.push(routeParams);
    }
  }
};
</script>